import { MatCheckboxDefaultOptions } from "@angular/material/checkbox";
import { RippleGlobalOptions } from "@angular/material/core";
import { MatFormFieldDefaultOptions } from "@angular/material/form-field";
import { MatRadioDefaultOptions } from "@angular/material/radio";
import { MatSelectConfig } from '@angular/material/select';

export const ACCOUNT_NUMBER_MAXLENGTH = 11;
export const  ACCOUNT_NUMBER_MINLENGTH = 11;
export const  ACCOUNT_NUMBER_PATTERN = /^([0-9]\\d*|0)$/;

/** mat form field  */
export const FPX_FORM_FIELD_DEFAULT_OPTIONS : MatFormFieldDefaultOptions = {
  appearance : 'outline',
  floatLabel : 'never',
  color : 'primary'
}


export const FPX_MAT_RADIO_DEFAULT_OPTIONS : MatRadioDefaultOptions = {
  color : 'primary'
}

export const FPX_MAT_DISABLE_RIPPLE : RippleGlobalOptions = {
  disabled : true
}

export const FPX_MAT_CHECKBOX_DEFAULT_OPTIONS : MatCheckboxDefaultOptions = {
  color : 'primary'
}

export const FPX_MAT_SELECT_DEFAULT_OPTIONS : MatSelectConfig = {
  disableOptionCentering : true
}

/** Date config */
export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  },
};
export const API_DATE_FORMAT = 'YYYY-MM-DD';

export const UPPERCASE = /[A-Z]/;
export const LOWERCASE = /[a-z]/;
export const SPECIALCHARS = /[!@#$%^&*]+/;

// !, $, #, ^ , @, &, %,*

export const ONLY_NUMARIC = /[0-9]/;